(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
(function (global){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Daws: Scroll animation library
 * Version: 1.0.0
 * @author Andy-dev http://andy-dev.space
 */

/*global WorkerGlobalScope */
// forEach polyfill
if (!Array.prototype.forEach) {
  Array.prototype.forEach = function (fn, scope) {
    'use strict';

    for (var i = 0, len = this.length; i < len; ++i) {
      fn.call(scope, this[i], i, this);
    }
  };
} // addEventListener polifill


(function (w) {
  // 
  var nc = '',
      nu = '',
      nr = '',
      t,
      a = 'addEventListener',
      n = a in w,
      c = (nc = 'Event') + (n ? (nc += '', 'Listener') : (nc += 'Listener', '')),
      u = n ? (nu = 'attach', 'add') : (nu = 'add', 'attach'),
      r = n ? (nr = 'detach', 'remove') : (nr = 'remove', 'detach');

  function evtf(whoe) {
    return function (evnt, func, capt) {
      return this[whoe](n ? (t = evnt.split('on'))[1] || t[0] : 'on' + evnt, func, !n && capt ? whoe.indexOf('detach') < 0 ? this.setCapture() : this.removeCapture() : capt);
    };
  }

  w[nu + nc] = Element.prototype[nu + nc] = document[nu + nc] = evtf(u + c);
  w[nr + nc] = Element.prototype[nr + nc] = document[nr + nc] = evtf(r + c);
})(window, document);
/*=============================================
=              Start Daws Code                =
=============================================*/


var _self = window !== 'undefined' ? window // if in browser
: WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope ? self // if in worker
: {} // if in node js
;

var Daws = function (_self) {
  'use strict';

  var ANIMATION = 'o/0/1';
  var _ = {};
  _ = {
    repeat: false,
    animation: 'fade-in',
    easing: 'easeInOutSine',
    duration: 1000,
    delay: 0,
    autoDelay: 100,
    autoDelayCount: 0,
    animationNamesList: {},
    animationClasses: {},
    elementsJsInit: [],
    elementsToBeRun: [],
    mobile: true,
    scrollableItem: null,
    observers: {},
    autoDelayTimeout: null,
    isDisable: false,
    myAnimationList: {},
    isInit: false,
    isOnLoad: false,
    dawsOnloadTimeout: function dawsOnloadTimeout() {},
    disable: function disable() {
      _.isDisable = true;
    },
    enable: function enable() {
      _.isDisable = false;
    },

    /**
     * Create List of the elements
     * @private
     * @param {string} attribute of the element
     * @return {Array} Elements to be animated
     */
    elementsAttr: function elementsAttr(attr) {
      var elements = document.querySelectorAll("[".concat(attr, "]"));
      elements = _.helper.nodesToArray(elements);
      return elements;
    },

    /**
     * Add new elements to elementsJsInit list
     * and init the animation with this new elements
     * @param {Array} of objects 
     */
    addElements: function addElements(arr) {
      arr = _.helper.isArray(arr) && arr.length ? arr : [];
      arr.forEach(function (el) {
        el.elements = _.helper.getNodes(el.elements);

        if (el.elements.length) {
          _.elementsJsInit.push(el);
        }
      }); //_.createElementsAttrs(_.elementsJsInit, 'data-daws');
      //_.startCreateFunctions('data-daws');
      //_.firstStart();
    },
    clear: function clear() {
      window.removeEventListener('scroll', _.scrollAction, true);
      _.animationClasses = {};
      _.animationNamesList = {};

      var removeStyleTag = function removeStyleTag(id) {
        var style = document.getElementById(id);

        if (style) {
          style.parentNode.removeChild(style);
        }
      };

      if (_.observers.observer) {
        _.observers.observer.disconnect();
      }

      removeStyleTag('daws_keyframes');
      removeStyleTag('daws_classes');

      _.elementsAttr('data-daws').forEach(function (node) {
        _.clearClasses(node); //node.removeAttribute('data-daws');

      });
    },
    clearClasses: function clearClasses(e) {
      var curClasses = (e.getAttribute('class') || '').split(' ');
      var curAnimClass = '';
      curClasses.forEach(function (item) {
        if (item.indexOf('daws-animation-') !== -1) {
          curAnimClass = item;
        }
      });

      if (e.classList.contains(curAnimClass)) {
        e.classList.remove(curAnimClass);
      }

      e.classList.remove('daws-animated');
    },

    /**
     * Init Daws function that check is IE, is Mobile,
     * creat observer and add scroll eventListener 
     * @param {Object} global options
     */
    init: function init(options) {
      _.setDefault();

      if (_.isOnload) {
        _.onLoad(options);
      } else {
        if (document) {
          if (document.readyState === 'complete') _.onLoad(options);

          if (document.readyState === 'interactive') {
            _.dawsOnloadTimeout = setTimeout(function () {
              _.onLoad(options);
            }, options && options.windowOnload ? options && options.windowOnloadTimeout || 5000 : 0);
          }

          document.addEventListener('readystatechange', function () {
            if (document.readyState === 'complete') _.onLoad(options);
          });
        }
      }
    },
    onLoad: function onLoad(options) {
      _.isOnload = true;

      if (_.helper.isIE() && _.helper.isIE() <= 9) {
        _.disableDaws();

        return;
      }

      options = _.helper.isObject(options) ? options : {};
      Object.keys(options).forEach(function (key) {
        _[key] = options[key];
      });

      if (!_.mobile) {
        if (_.helper.isMobile()) {
          _.disableDaws();

          return;
        }
      } // Add global standart animation


      var _animation = _.helper.getAnimation(_.animation);

      if (!_.animationNamesList[_animation.replace(/\s/g, '')]) {
        _.animationNamesList[_animation.replace(/\s/g, '')] = 'daws-animation-1';
      } // check browser tab is active


      var hidden;
      var visibilityChange;

      if (typeof document.hidden !== 'undefined') {
        // Opera 12.10 and Firefox 18 and later support 
        hidden = 'hidden';
        visibilityChange = 'visibilitychange';
      } else if (typeof document.msHidden !== 'undefined') {
        hidden = 'msHidden';
        visibilityChange = 'msvisibilitychange';
      } else if (typeof document.webkitHidden !== 'undefined') {
        hidden = 'webkitHidden';
        visibilityChange = 'webkitvisibilitychange';
      }

      function handleVisibilityChange() {
        if (!document[hidden]) {
          _.firstStart();

          document.removeEventListener(visibilityChange, handleVisibilityChange, false);
        }
      }

      _.createElementsAttrs(_.elementsJsInit, 'data-daws');

      _.startCreateFunctions('data-daws');

      _.firstStart();

      document.addEventListener(visibilityChange, handleVisibilityChange, false); // main scroll action

      window.addEventListener('scroll', _.scrollAction, true);
    },

    /**
     * Function grouping for convenience
     * @private
     * @param {string} name of the main attribute
     */
    startCreateFunctions: function startCreateFunctions(attr) {
      _.createAnimationNamesList(attr);

      _.buildStyleSheet(_.animationNamesList);

      _.createAnimationClassesList(attr);
    },

    /** 
     * Function that takes the current list of elements
     * and start tracking
     * @private
     */
    scrollAction: function scrollAction() {
      if (_.isDisable) {
        return;
      }

      _.elementsAttr('data-daws').forEach(function (node) {
        _.playAnimation(node); //_.determineNode(node);
        // if(node.tagName == 'IMG') {
        //   _.determineNode(node);
        // } else {
        //   _.determineNode(node);
        // }

      });
    },
    firstStart: function firstStart() {
      if (_.isDisable) return;
      var observerOptions = {
        threshold: 0.001
      };

      if (window.IntersectionObserver) {
        _.observers.observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (_.isDisable) {
              return;
            }

            _.playAnimation(entry.target, entry.isIntersecting);
          });
        }, observerOptions);
      }

      _.elementsAttr('data-daws').forEach(function (node) {
        if (_.observers.observer) {
          _.observers.observer.observe(node);
        } else {
          _.playAnimation(node);
        }
      });

      setTimeout(function () {
        if (_.observers.observer) _.observers.observer.disconnect();
      }, 100);
    },

    /**
     * Creates a list of animation names ( animationNamesList )
     * that will need to be created, and used later.
     * @private
     * @param {String} Name of the main attribute ( data-daws )  
     */
    createAnimationNamesList: function createAnimationNamesList(attr) {
      _.elementsAttr(attr).forEach(function (elementAttr) {
        var dawsAttr = elementAttr.getAttribute(attr);

        var dataOptions = _.helper.getDataOptions(dawsAttr);

        if (dataOptions.animation) {
          var animName = _.helper.getAnimation(dataOptions.animation);

          if (!_.animationNamesList[animName]) {
            _.animationNamesList[animName] = 'daws-animation-' + (Object.keys(_.animationNamesList).length + 1);
          }
        }
      });
    },

    /**
     * Building css animations styles ( @keyframes )
     * and put them to style tag in the head tag
     * @private
     * @param {Object} list of animation names ( animationNamesList )
     */
    buildStyleSheet: function buildStyleSheet(list) {
      var animationStyleSheets = [];
      Object.keys(list).forEach(function (animation) {
        animation = _.helper.getAnimation(animation);
        var params = animation.split(',');
        var _items = {
          opacity: [['o', '0', '1']]
        };
        params.map(function (param) {
          var _param = param.split('/');

          _.transformsList.map(function (item) {
            if (item === _param[0]) {
              _items.transform = _items.transform || [];

              _items.transform.push(_param);
            }
          });

          _.filtersList.map(function (item) {
            if (item === _param[0]) {
              _items.filter = _items.filter || [];

              _items.filter.push(_param);
            }
          });

          _.cssProperties.map(function (item) {
            if (item === _param[0]) {
              _items[_.cssPropsNames[_param[0]]] = _items[_.cssPropsNames[_param[0]]] || [];
              _items[_.cssPropsNames[_param[0]]][0] = _param;
            }
          });
        });
        var keyFrames = {
          name: _.animationNamesList[animation.replace(/\s/g, '')],
          from: [],
          to: []
        };
        Object.keys(_items).forEach(function (key) {
          var _from = [];
          var _to = [];

          _items[key].map(function (param) {
            //let id = param[0];
            var fromValue = Number(param[1].replace(/[^0-9.]+/g, ''));
            var unit = param[1].match(/[a-zA-Z%]+/g) || '';
            var minus = param[1].indexOf('-') !== -1 ? '-' : '';
            var to = Number(param[2]) || 0;

            if (minus === '-') {
              fromValue = fromValue * -1;
            }

            var cssPropertyFrom = '';
            var cssPropertyTo = '';

            if (_.cssPropsNames[param[0]]) {
              cssPropertyFrom = "".concat(fromValue).concat(unit);
              cssPropertyTo = "".concat(to).concat(unit);
            } else {
              cssPropertyFrom = "".concat(_.stylesProperty[param[0]], "(").concat(fromValue).concat(unit, ")");
              cssPropertyTo = "".concat(_.stylesProperty[param[0]], "(").concat(to).concat(unit, ")");
            }

            _from.push(cssPropertyFrom);

            _to.push(cssPropertyTo);
          });

          var fromRes = {};
          var toRes = {};
          Object.keys(_.helper.vendorPrefixes).forEach(function (prefix) {
            if (_.helper.vendorPrefixes['webkit'][key]) {
              fromRes[prefix] = "".concat(_.helper.vendorPrefixes[prefix]['transform']).concat(key, ":").concat(_from.join(' '), ";");
              toRes[prefix] = "".concat(_.helper.vendorPrefixes[prefix]['transform']).concat(key, ":").concat(_to.join(' '), ";");
            } else {
              fromRes[prefix] = "".concat(key, ":").concat(_from.join(' '), ";");
              toRes[prefix] = "".concat(key, ":").concat(_to.join(' '), ";");
            }
          });
          keyFrames.from.push(fromRes);
          keyFrames.to.push(toRes);
        });
        var cssKeyFramesAnimation = '';
        Object.keys(_.helper.vendorPrefixes).forEach(function (prefix) {
          var _from = '',
              _to = '';
          keyFrames.from.map(function (item) {
            _from += item[prefix];
          });
          keyFrames.to.map(function (item) {
            _to += item[prefix];
          });
          cssKeyFramesAnimation += "".concat(_.helper.vendorPrefixes[prefix]['keyFrames'], " ").concat(keyFrames.name, "{from{").concat(_from, "}to{").concat(_to, "}}");
        });
        animationStyleSheets.push(cssKeyFramesAnimation);
      });
      var cssText = animationStyleSheets.join(''); // create style tag in the head tag

      _.helper.addToStyleTag(cssText, 'daws_keyframes');
    },

    /**
     * Preparing items for creating the list of classes
     * @private
     * @param {String} Name of the main attribute ( data-daws )  
     */
    createAnimationClassesList: function createAnimationClassesList(attr) {
      _.elementsAttr(attr).forEach(function (elementAttr) {
        var dawsAttr = elementAttr.getAttribute(attr);

        var dataOptions = _.helper.getDataOptions(dawsAttr);

        if (dataOptions) {
          _.buildClasses(elementAttr, dataOptions);
        }
      });
    },

    /**
     * Create a list of classes
     * that will need to be created, and used later.
     * @private
     * @param {Element} target The DOM element to create class.
     * @param {Object} Animation Options ( duration, easing etc... ).
     */
    buildClasses: function buildClasses(elem, options) {
      var animationName = 'daws-animation-1';
      var duration = _.duration;

      var easing = _.helper.createBezierFromName(_.easing);

      var _options = {};

      if (Object.keys(options).length > 0) {
        if (options.animation) {
          animationName = _.helper.getAnimation(options.animation);
          _options.animation = animationName;
          animationName = _.animationNamesList[animationName];
        }

        if (options.easing) {
          easing = _.helper.createBezierFromName(options.easing);
          _options.easing = easing;
        }

        if (options.duration) {
          duration = options.duration;
          _options.duration = duration;
        }
      }

      var animationClassName = _.helper.getClassName(_options, '.');

      var animationCssProps = '';
      Object.keys(_.helper.vendorPrefixes).forEach(function (prefix) {
        animationCssProps += "".concat(_.helper.vendorPrefixes[prefix]['animation'], "animation: ").concat(animationName, " ").concat(duration / 1000, "s cubic-bezier(").concat(easing, ") forwards;");
      });

      if (!_.animationClasses[animationClassName]) {
        _.animationClasses[animationClassName] = animationCssProps;
        var cssText = "".concat(animationClassName, "{").concat(animationCssProps, "}"); // create style tag in the head tag

        _.helper.addToStyleTag(cssText, 'daws_classes');
      }
    },

    /**
     * Adding to list of animation names ( animationNamesList )
     * that will need to be created, and used later.
     * @private
     * @param {Array} of Elements
     */
    addAnimationStyleSheet: function addAnimationStyleSheet(arr) {
      var newList = {};
      arr.forEach(function (item) {
        if (item.options && item.options.animation) {
          var animName = _.helper.getAnimation(item.options.animation);

          if (!_.animationNamesList[animName]) {
            _.animationNamesList[animName] = 'daws-animation-' + (Object.keys(_.animationNamesList).length + 1);
            newList[animName] = 'daws-animation-' + Object.keys(_.animationNamesList).length;
          }
        }
      });

      _.buildStyleSheet(newList);
    },

    /**
     * Adding attribute with options to new elements
     * @private
     * @param {Array} array of Object with elements and options
     */
    createElementsAttrs: function createElementsAttrs(elements, attr) {
      var createDawsAttr = function createDawsAttr(elem, options) {
        var _options = '';
        Object.keys(options).forEach(function (option) {
          _options += "".concat(option, ":").concat(options[option], ";");
        });
        elem.setAttribute(attr, _options);
      };

      elements.forEach(function (el) {
        el.elements.forEach(function (nodes) {
          if (_.helper.isArray(nodes) && nodes.length) {
            nodes.forEach(function (node) {
              //console.log(node);
              if (_.helper.isArray(node) && node.length) {
                node.forEach(function (node) {
                  createDawsAttr(node, el.options);
                });
              } else {
                createDawsAttr(node, el.options);
              }
            });
          }
        });
      });
    },

    /**
     * Reset some of default values
     * @private
     */
    setDefault: function setDefault() {
      _.repeat = false;
      _.easing = 'easeInOutSine';
      _.duration = 1000;
      _.delay = 0;
      _.autoDelay = 100;
      _.autoDelayCount = 0;
      _.mobile = true;
    },

    /**
     * Remove scroll listener, disconnect observer,
     * clear style tags, clear classes,
     * set default values
     */
    destroy: function destroy() {
      _.setDefault();

      _.elementsJsInit = [];
      _.animationClasses = {};
      _.animationNamesList = {};

      var removeStyleTag = function removeStyleTag(id) {
        var style = document.getElementById(id);

        if (style) {
          style.parentNode.removeChild(style);
        }
      };

      if (_.observers.observer) {
        _.observers.observer.disconnect();
      }

      removeStyleTag('daws_keyframes');
      removeStyleTag('daws_classes');
    },

    /**
     * Add class daws-dis to the elements
     */
    disableDaws: function disableDaws() {
      _.elementsAttr('data-daws').forEach(function (elementAttr) {
        elementAttr.classList.add('daws-dis');
      });
    },

    /**
     * Get options list, selects the desired className
     * and add it to the element, if the conditions are met
     * @private
     * @param {Element} DOM element.
     * @param {Boolean} Element is visable.
     */
    playAnimation: function playAnimation(e, isInteresting) {
      //console.log(e);
      try {
        var dawsAttr = e.getAttribute('data-daws');

        var dataOptions = _.helper.getDataOptions(dawsAttr);

        var justClass = dataOptions.justClass || false;
        var forceStart = dataOptions.forceStart || false;
        var repeat = _.helper.isBool(dataOptions.repeat) ? dataOptions.repeat : _.repeat;
        var curClasses = (e.getAttribute('class') || '').split(' ');
        var curAnimClass = ''; //let isRun = dataOptions.isRun || false;

        var elProps = e.getBoundingClientRect();
        var scrollableItem = scrollableItem || _.scrollableItem || window;
        var elPos = Math.round(elProps.top + _.helper.YOffset(scrollableItem));

        var condition = elPos < _.helper.YOffset(scrollableItem) + window.innerHeight && elPos + elProps.height > _.helper.YOffset(scrollableItem);

        curClasses.forEach(function (item) {
          if (item.indexOf('daws-animation-') !== -1) {
            curAnimClass = item;
          }
        });

        if (forceStart) {
          isInteresting = true;
        }

        if (condition || isInteresting) {
          var animation = '';

          var delay = Number(dataOptions.delay) || _.delay;

          var autoDelay = Number(dataOptions.autoDelay) || _.autoDelay;

          var duration = Number(dataOptions.duration) || _.duration;

          var easing = dataOptions.easing || _.easing;

          if (!justClass) {
            animation = dataOptions.animation || _.animation;
            easing = _.helper.createBezierFromName(easing); // if (isRun) {
            //   e.classList.remove('daws-animated');
            //   if(curAnimClass) {
            //     e.classList.remove(curAnimClass);
            //   }
            // }
          }

          if (!e.classList.contains('daws-animated')) {
            var animClassName = _.helper.getClassName({
              animation: animation,
              duration: duration,
              easing: easing
            });

            var styles = window.getComputedStyle(e, null);

            if (styles.display && styles.display === 'inline') {
              e.style.display = 'inline-block';
            }

            _.autoDelayCount = _.autoDelayCount + Number(autoDelay);
            setTimeout(function () {
              if (_.helper.isString(justClass)) {
                e.classList.add(justClass);
              } else {
                e.classList.add(animClassName);
              }
            }, delay + _.autoDelayCount);
            clearInterval(_.autoDelayTimeout);
            _.autoDelayTimeout = setTimeout(function () {
              _.autoDelayCount = 0;
            }, 300);
            e.classList.add('daws-animated');
          }
        } else if (!condition) {
          if (repeat) {
            if (curAnimClass) {
              e.classList.remove(curAnimClass);
            }

            e.classList.remove('daws-animated');
            e.classList.remove(justClass);
          }
        }
      } catch (err) {//console.log(err);
      }
    },

    /**
     * Object of helpfull functions and objects
     * @private
     */
    helper: {
      isSet: function isSet(obj) {
        return obj !== null || obj !== undefined;
      },
      isBool: function isBool(obj) {
        return typeof obj === 'boolean' || obj === 'true' || obj === 'false';
      },
      strToBool: function strToBool(obj) {
        return obj === 'true' ? true : false;
      },
      isString: function isString(obj) {
        return typeof obj === 'string' || obj instanceof String;
      },
      isObject: function isObject(obj) {
        return _typeof(obj) === 'object' && !(obj instanceof Array);
      },
      isArray: function isArray(obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
      },
      vendorPrefixes: {
        webkit: {
          keyFrames: '@-webkit-keyframes',
          transform: '-webkit-',
          filter: '-webkit-',
          animation: '-webkit-'
        },
        moz: {
          keyFrames: '@-moz-keyframes',
          transform: '-moz-',
          filter: '-moz-',
          animation: '-moz-'
        },
        o: {
          keyFrames: '@-o-keyframes',
          transform: '-o-',
          filter: '-o-',
          animation: '-o-'
        },
        standart: {
          keyFrames: '@keyframes',
          transform: '',
          filter: '',
          animation: ''
        }
      },

      /**
       * Create Object of animation options from attribut
       * @private
       * @param {String} string from attribute.
       * @return {Object} of animation options 
       */
      getDataOptions: function getDataOptions(options) {
        var settings = {};

        if (options) {
          options = options.split(';');
          options.forEach(function (option) {
            option = option.replace(/\s/g, '');

            if (option !== '') {
              option = option.split(':');

              if (_.helper.isBool(option[1])) {
                settings[option[0]] = _.helper.strToBool(option[1]);
              } else {
                settings[option[0]] = option[1];
              }
            }
          });
        }

        delete settings["true"];
        return settings;
      },

      /**
       * Add css stylesheets to style tag in the head tag
       * @private
       * @param {String} css stylesheet.
       * @param {String} id of style tag 
       */
      addToStyleTag: function addToStyleTag(cssText, id) {
        var style = document.getElementById(id);

        if (!style) {
          var head = document.head || document.getElementsByTagName('head')[0];
          style = document.createElement('style');
          style.id = id;
          style.type = 'text/css';
          head.appendChild(style);
        }

        if (style.styleSheet) {
          style.styleSheet.cssText = cssText; // This is required for IE8 and below.
        } else {
          style.appendChild(document.createTextNode(cssText));
        }
      },

      /**
       * Defining the desired class to add to elements
       * and create a style sheet
       * @private
       * @param {Object} animation options.
       * @param {String} if need dot before class name
       * @return {String} the desired class
       */
      getClassName: function getClassName(options, dot) {
        var animationName = 'daws-animation-1';
        var duration = _.duration;

        var easing = _.helper.createBezierFromName(_.easing);

        if (Object.keys(options).length > 0) {
          if (options.animation) {
            animationName = _.helper.getAnimation(options.animation);
            animationName = _.animationNamesList[animationName];
          }

          if (options.easing) {
            easing = _.helper.createBezierFromName(options.easing); // console.log(easing);
          }

          if (options.duration) {
            duration = options.duration;
          }
        }

        return (dot || '') + animationName + '_' + easing.replace(/[\s,.]/g, '').toLowerCase() + duration;
      },

      /**
       * Condition to Check is mobile
       * @private
       * @return {Boolean}
       */
      isMobileCondition: function isMobileCondition() {
        //eslint-disable-next-line
        return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(navigator.userAgent || navigator.vendor || window.opera) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent || navigator.vendor || window.opera.substr(0, 4));
      },

      /**
       * Format easing to bezier
       * easeOutBack to "0.17,0.89,0.32,1.27"
       * or [0.17, 0.89, 0.32, 1.27] to "0.17,0.89,0.32,1.27"
       * @private
       * @param {String | Array} easing bezier
       * @return {String} "0.17,0.89,0.32,1.27"
       */
      createBezierFromName: function createBezierFromName(name) {
        if (_.helper.isArray(name) && name.length > 3) {
          name = name.join(', ');
        } else if (_.helper.isString(name) && name.split(',').length === 4) {
          return name;
        } else {
          var easingExist = false;
          Object.keys(_.standartEasings).forEach(function (key) {
            if (name.toLowerCase() === key.toLowerCase()) {
              easingExist = true; //console.log('bezier', key);

              name = _.standartEasings[key];
            }
          });

          if (!easingExist) {
            name = '0.445,0.05,0.55,0.95';
          }
        }

        return name;
      },

      /**
       * Find offset top
       * @private
       * @param {Element} Dom Element ( window, body, etc... )
       * @return {Number} offset top
       */
      YOffset: function YOffset(item) {
        return item.scrollTop || item.pageYOffset;
      },

      /**
       * Transform Dom elements collection to array
       * @private
       * @param {Elements} Collection of Dom Elements
       * @return {Array} array of elements
       */
      nodesToArray: function nodesToArray(nodes) {
        if (nodes && nodes.length) {
          var resArr = [];

          for (var i = 0; i < nodes.length; i++) {
            resArr.push(nodes[i]);
          }

          return resArr;
        }

        return [];
      },

      /**
       * Forms the name of the animation if necessary
       * @private
       * @param {String} animation name ( "up-right" or "y/30px,x-60px" )
       * @return {String} animation name
       */
      getAnimation: function getAnimation(name) {
        if (typeof name !== 'string') {
          return ANIMATION;
        }

        var nameExist = false;
        Object.keys(_.animationList).forEach(function (list) {
          Object.keys(_.animationList[list]).forEach(function (key) {
            if (name.replace(/\s/g, '') === key.replace(/\s/g, '')) {
              name = _.animationList[list][key].replace(/\s/g, '').toLowerCase();
              nameExist = true;
            }
          });
        });
        Object.keys(_.myAnimationList).forEach(function (key) {
          if (name.replace(/\s/g, '') === key.replace(/\s/g, '')) {
            if (_.myAnimationList[key] !== '') {
              name = _.myAnimationList[key].replace(/\s/g, '').toLowerCase();
            } else {
              name = ANIMATION;
            }

            nameExist = true;
          }
        });

        if (!nameExist && _.helper.isAnimationCode(name)) {
          return ANIMATION;
        }

        name.replace(/\s/g, '').toLowerCase();
        return name;
      },

      /**
       * Check is animation string is valid animation code
       * @private
       * @param {String} animation code
       * @return {Boolean}
       */
      isAnimationCode: function isAnimationCode(str) {
        var _str = str.split(',');

        _str = _str[0].split('/');

        if (_.helper.isArray(_str) && _str.length < 2) {
          return true;
        }

        return false;
      },

      /**
       * Check is mobile
       * @private
       * @return {Boolean}
       */
      isMobile: function isMobile() {
        if (_.helper.isMobileCondition()) {
          return true;
        } else {
          return false;
        }
      },

      /**
       * Create list of DOM Elements from array of lists
       * selectors or DOM Elements collections 
       * @private
       * @param {Array} array of Array or selectors of DOM Elements
       * @return {Array} array of DOM elements
       */
      getNodes: function getNodes(elements) {
        var _elements = [];

        if (_.helper.isArray(elements) && elements.length) {
          _elements = _.helper.nodesToArray(elements);
        } else if (elements == '[object NodeList]') {
          _elements = _.helper.nodesToArray(elements);
        } else {
          _elements.push(elements);
        }

        _elements.forEach(function (item, index) {
          if (item) {
            if (_.helper.isString(item)) {
              _elements[index] = _.helper.nodesToArray(document.querySelectorAll(item));
            } else if (!_.helper.isArray(item)) {
              _elements[index] = [];

              _elements[index].push(item);
            }
          }
        });

        return _elements;
      },

      /**
       * Check is IE
       * @private
       * @return {Boolean | Number} return false or IE version
       */
      isIE: function isIE() {
        var myNav = navigator.userAgent.toLowerCase();
        return myNav.indexOf('msie') !== -1 ? parseInt(myNav.split('msie')[1]) : false;
      }
    },
    // end of the Helpers.

    /**
     * Add custom animation names values list
     * @param {String} name of the animation.
     * @param {String} animation constructor code (y/30px,rt/50deg)
     */
    addToMyList: function addToMyList(key, value) {
      if (!_.myAnimationList[key]) {
        _.myAnimationList[key] = value;
      }
    },
    stylesProperty: {
      p: 'perspective',
      x: 'translateX',
      y: 'translateY',
      rt: 'rotate',
      ry: 'rotateY',
      rx: 'rotateX',
      rz: 'rotateZ',
      s: 'scale',
      sy: 'scaleY',
      sx: 'scaleX',
      sz: 'scaleZ',
      swy: 'skewY',
      swx: 'skewX',
      bl: 'blur',
      br: 'brightness',
      gs: 'grayscale',
      inv: 'invert',
      hr: 'hue-rotate',
      cr: 'contrast',
      st: 'saturate',
      sp: 'sepia'
    },
    transformsList: ['p', 'y', 'x', 'rt', 'ry', 'rx', 'rz', 's', 'sy', 'sx', 'sz', 'swy', 'swx'],
    filtersList: ['bl', 'br', 'gs', 'inv', 'hr', 'cr', 'st', 'sp'],
    cssProperties: ['o', 't', 'r', 'b', 'l', 'w', 'h', 'mt', 'mb', 'ml', 'mr', 'pt', 'pb', 'pl', 'pr'],
    cssPropsNames: {
      o: 'opacity',
      t: 'top',
      r: 'right',
      b: 'bottom',
      l: 'left',
      w: 'width',
      h: 'height',
      mt: 'margin-top',
      mb: 'margin-bottom',
      ml: 'margin-left',
      mr: 'margin-right',
      pt: 'padding-top',
      pb: 'padding-bottom',
      pl: 'padding-left',
      pr: 'padding-right'
    },
    standartEasings: {
      easeInSine: '0.47,0,0.745,0.715',
      easeOutSine: '0.39,0.575,0.565,1',
      easeInOutSine: '0.445,0.05,0.55,0.95',
      easeInQuad: '0.55,0.085,0.68,0.53',
      easeOutQuad: '0.25,0.46,0.45,0.94',
      easeInOutQuad: '0.455,0.03,0.515,0.955',
      easeInCubic: '0.55,0.055,0.675,0.19',
      easeOutCubic: '0.215,0.61,0.355,1',
      easeInOutCubic: '0.645,0.045,0.355,1',
      easeInQuart: '0.895,0.03,0.685,0.22',
      easeOutQuart: '0.165,0.84,0.44,1',
      easeInOutQuart: '0.77,0,0.175,1',
      easeInQuint: '0.755,0.05,0.855,0.06',
      easeOutQuint: '0.23,1,0.32,1',
      easeInOutQuint: '0.86,0,0.07,1',
      easeInExpo: '0.95,0.05,0.795,0.035',
      easeOutExpo: '0.19,1,0.22,1',
      easeInOutExpo: '1,0,0,1',
      easeInCirc: '0.6,0.04,0.98,0.335',
      easeOutCirc: '0.075,0.82,0.165,1',
      easeInOutCirc: '0.785,0.135,0.15,0.86',
      easeInBack: '0.6,-0.28,0.735,0.045',
      easeOutBack: '0.175,0.885,0.32,1.275',
      easeInOutBack: '0.68,-0.55,0.265,1.55'
    }
  };
  _self.Daws = _;
  return _;
}(_self);

if (module !== 'undefined' && module.exports) {
  module.exports = Daws;
} //hack for components to work correctly in node.js


if (global !== 'undefined') {
  global.Daws = Daws;
}
/*=============================================
=              Animations List                =
=============================================*/


Daws.animationList = {
  simple: {
    'fade-in': 'o/0/1',
    up: 'y/-30px',
    down: 'y/30px',
    right: 'x/30px',
    left: 'x/-30px',
    increase: 's/0.5/1',
    decrease: 's/1.5/1',
    rotate: ' rt/180deg'
  },
  modern: {
    'falling-paper-right': 'p/500px/500,ry/-30deg,x/140px,s/1.1/1',
    'falling-paper-down': 'p/500px/500,rx/30deg,y/140px,s/1.1/1',
    'snake-left': 'p/500px/500,ry/-170deg,s/1.2/1,swy/-20deg,x/200px',
    'touchdown-left': 'p/500px/500,rx/180deg,x/-300px,s/2/1,rz/30deg,bl/3px',
    'touchdown-right': 'p/500px/500,rx/-180deg,x/300px,s/2/1,rz/30deg,bl/3px',
    'roll-from-left': 'x/-200px,rz/-360deg',
    'roll-from-right': 'x/200px,rz/360deg',
    'artful-zoom': 's/0/1,rx/180deg,y/70px'
  },
  natty: {
    'flip-from-right': 'p/500px/500,rx/180deg,x/20px',
    'scale-rotate': 's/0.6/1,rt/-23deg',
    'docking': 'p/600px/600,rx/-15deg,y/50px,s/0.9/1',
    'i-will-fit-here': 'p/500px/500,s/0.95/1,rx/2deg,ry/2deg,y/-20px,x/20px',
    'trivially-not-usually': 'y/20px,rx/40deg',
    'at-an-angle': 'p/100px/100,y/10px,rz/1deg,sx/1.02/1',
    'ghostly': 'swx/90deg,s/1.2/1',
    'pull-from-top': 'sy/1.2/1,y/-10px',
    'constructively': 'x/40px,swx/30deg,s/0.9/1'
  },
  fasion: {},
  crazy: {}
};
/**
 * Element.prototype.classList for IE8/9, Safari.
 * @author    Kerem Güneş <k-gun@mail.com>
 * @copyright Released under the MIT License <https://opensource.org/licenses/MIT>
 * @version   1.2
 * @see       https://developer.mozilla.org/en-US/docs/Web/API/Element/classList
 */

(function () {
  // Helpers.
  var trim = function trim(s) {
    return s.replace(/^\s+|\s+$/g, '');
  },
      regExp = function regExp(name) {
    return new RegExp('(^|\\s+)' + name + '(\\s+|$)');
  },
      forEach = function forEach(list, fn, scope) {
    for (var i = 0; i < list.length; i++) {
      fn.call(scope, list[i]);
    }
  }; // Class list object with basic methods.


  function ClassList(element) {
    this.element = element;
  }

  ClassList.prototype = {
    add: function add() {
      forEach(arguments, function (name) {
        if (!this.contains(name)) {
          this.element.className = trim(this.element.className + ' ' + name);
        }
      }, this);
    },
    remove: function remove() {
      forEach(arguments, function (name) {
        this.element.className = trim(this.element.className.replace(regExp(name), ' '));
      }, this);
    },
    toggle: function toggle(name) {
      return this.contains(name) ? (this.remove(name), false) : (this.add(name), true);
    },
    contains: function contains(name) {
      return regExp(name).test(this.element.className);
    },
    item: function item(i) {
      return this.element.className.split(/\s+/)[i] || null;
    },
    // bonus
    replace: function replace(oldName, newName) {
      this.remove(oldName), this.add(newName);
    }
  }; // IE8/9, Safari
  // Remove this if statements to override native classList.

  if (!('classList' in Element.prototype)) {
    // Use this if statement to override native classList that does not have for example replace() method.
    // See browser compatibility: https://developer.mozilla.org/en-US/docs/Web/API/Element/classList#Browser_compatibility.
    // if (!('classList' in Element.prototype) ||
    //     !('classList' in Element.prototype && Element.prototype.classList.replace)) {
    Object.defineProperty(Element.prototype, 'classList', {
      get: function get() {
        return new ClassList(this);
      }
    });
  } // For others replace() support.


  if (window.DOMTokenList && !DOMTokenList.prototype.replace) {
    DOMTokenList.prototype.replace = ClassList.prototype.replace;
  }
})();

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}]},{},[1]);
